export class InvalidCredentialsError extends Error {
  constructor() {
    super('The email or password is incorrect.');
    this.name = 'InvalidCredentialsError';
  }
}

export class EmailNotVerifiedError extends Error {
  constructor() {
    super('This account has not verified its email yet.');
    this.name = 'EmailNotVerifiedError';
  }
}

export class EmailAlreadyInUseError extends Error {
  constructor() {
    super('An account with this email already exists.');
    this.name = 'EmailAlreadyInUseError';
  }
}

export class SignUpFailedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SignUpFailedError';
  }
}

export class UnknownAuthError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'UnknownAuthError';
  }
}

export class InvalidCurrentPasswordError extends Error {
  constructor() {
    super('The current password is incorrect.');
    this.name = 'InvalidCurrentPasswordError';
  }
}

export class PasswordTooShortError extends Error {
  constructor(message = 'The new password is too short.') {
    super(message);
    this.name = 'PasswordTooShortError';
  }
}

export class PasswordTooLongError extends Error {
  constructor(message = 'The new password is too long.') {
    super(message);
    this.name = 'PasswordTooLongError';
  }
}

export class CredentialAccountNotFoundError extends Error {
  constructor() {
    super('This account does not have a password to change.');
    this.name = 'CredentialAccountNotFoundError';
  }
}

export class ChangePasswordFailedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ChangePasswordFailedError';
  }
}

export class RequestPasswordResetFailedError extends Error {
  constructor(message = 'We could not send a password reset email right now.') {
    super(message);
    this.name = 'RequestPasswordResetFailedError';
  }
}

export class InvalidResetTokenError extends Error {
  constructor(message = 'This password reset link is invalid or has expired.') {
    super(message);
    this.name = 'InvalidResetTokenError';
  }
}

export class ResetPasswordFailedError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ResetPasswordFailedError';
  }
}

export type SignInError = InvalidCredentialsError | EmailNotVerifiedError | UnknownAuthError;

export type SignUpError = EmailAlreadyInUseError | SignUpFailedError | UnknownAuthError;

export type SignOutError = UnknownAuthError;

export type GetSessionError = UnknownAuthError;

export type ChangePasswordError =
  | InvalidCurrentPasswordError
  | PasswordTooShortError
  | PasswordTooLongError
  | CredentialAccountNotFoundError
  | ChangePasswordFailedError
  | UnknownAuthError;

export type RequestPasswordResetError = RequestPasswordResetFailedError | UnknownAuthError;

export type ResetPasswordError =
  | InvalidResetTokenError
  | PasswordTooShortError
  | PasswordTooLongError
  | ResetPasswordFailedError
  | UnknownAuthError;
